
/**
 * Obtenir une traduction si le code existe.
 * @param clef
 * @param params
 */
export const T = (clef: string, ...params: any[]) => {
    const UNKNOWN_FORMAT = '???{}???';

    if (clef)
    {
        var effectiveClef = 'web.' + clef;
        var valeur = (window['_T'] || {})[effectiveClef];
        if (valeur)
        {
            var nbArguments = params.length;
            var traduction = valeur;
            for (var i = 0; i < nbArguments; i++)
            {
                traduction = traduction.replace('{' + i + '}', params[i] === null ? '' : params[i]);
            }
            return traduction;
        }
        else
        {
            return UNKNOWN_FORMAT.replace('{}', clef);
        }
    }
};

